import { Button, ButtonProps } from "@kaltura/ds-react-components";
import {useButtonAnalytics} from "@mediaspace/hooks";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";

/**
 * replace media link to be used on conversion error
 *
 */
export const ReplaceMediaAction = (props: ButtonProps) => {
	const { href, size, children } = props;

    const sendButtonAnalytics = useButtonAnalytics();

    const sendAnalytics = () => {
        sendButtonAnalytics("Media Hero - Upload again", ButtonClickAnalyticsType.ADD);
    }

	return (
		<Button
            component={"a"}
            size={size}
            href={href}
            onClick={sendAnalytics}
        >
			{children}
		</Button>
	);
};
export default ReplaceMediaAction;
